module.exports = __webpack_public_path__ + "static/media/J24-Mobile-Banner.f6d7d476.jpg";